import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'components/Loading';
import Message from '../Message';

export default function MessageList({ messages, type }) {
  if (!messages) {
    return <Loading />;
  }
  if (messages.length) {
    return messages.map(message => <Message key={message.relatedId} data={message} type={type} />);
  }
  return <p>No messages</p>;
}

MessageList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  type: PropTypes.string,
};

MessageList.defaultProps = {
  type: undefined,
};